import gql from 'graphql-tag'

import BASE from './Base'

export default gql`
  fragment ParticipantWithEmailHistorics on Participant {
    ...ParticipantBase
    participantEmailHistorics {
      date
      emailModel
    }
  }
  ${BASE}
`
